import { RegisterService } from "./register/register.service";
import { MetaDataService } from "./metaData/meta-data.service";
import { HelperService } from "./helper/helper.service";
import { MetadataResolver } from "./metaData-resolver/metaData-reolver.resolver.service";
import { LoginService } from "./login/login.service";
import { NotificationService } from "./notification/notification.service";
import { UploadFilesService } from "./upload-files/upload-files.service";
import { JwtInterceptorService } from "./jwt-interceptor/jwt-interceptor.service";
import { ErrorInterceptorService } from "./error-interceptor/error-interceptor.service";
import { CampaignService } from "./campaign/campaign.service";
import { EnumService } from "./enum/enum.service";
import { UserService } from "./user/user.service";
import { RechargeService } from "./recharge/recharge.service";
import { ReportService } from "./reports/report.service";

export const services: any[] = 
[ 
    RegisterService, 
    MetaDataService, 
    HelperService, 
    MetadataResolver, 
    LoginService, 
    NotificationService,
    UploadFilesService,
    JwtInterceptorService,
    ErrorInterceptorService,
    CampaignService,
    EnumService,
    UserService,
    RechargeService,
    ReportService 
];

export * from "./register/register.service";
export * from "./metaData/meta-data.service";
export * from "./helper/helper.service";
export * from "./metaData-resolver/metaData-reolver.resolver.service";
export * from "./login/login.service";
export * from "./notification/notification.module";
export * from "./notification/notification.service";
export * from "./upload-files/upload-files.service";
export * from "./jwt-interceptor/jwt-interceptor.service";
export * from "./error-interceptor/error-interceptor.service";
export * from "./campaign/campaign.service";
export * from "./enum/enum.service";
export * from "./user/user.service";
export * from "./recharge/recharge.service";
export * from "./reports/report.service";